/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Meta } from '@micromag/core/components';
// import * as AppPropTypes from '../../lib/PropTypes';
import { usePage, useDomain } from '../../contexts/SiteContext';

const propTypes = {
    title: PropTypes.string,
    fullTitle: PropTypes.string,
};

const defaultProps = {
    title: null,
    fullTitle: null,
};

const PageMeta = ({ title, fullTitle }) => {
    const intl = useIntl();
    const domain = useDomain();
    const suffix =
        domain === 'studio'
            ? intl.formatMessage({ defaultMessage: 'Micromag Studio', description: 'Site name' })
            : intl.formatMessage({ defaultMessage: 'Micromag', description: 'Site name' });
    const { title: pageTitle = null, url = null, metadata = {} } = usePage() || {};
    const currentPageTitle = fullTitle === null ? title || pageTitle : null;
    return (
        <Meta
            title={currentPageTitle}
            url={url}
            metadata={metadata}
            fullTitle={fullTitle}
            suffix={suffix}
        />
    );
};

PageMeta.propTypes = propTypes;
PageMeta.defaultProps = defaultProps;

export default PageMeta;
